import secureLocalStorage from "react-secure-storage";
import { CircularProgress, Switch, Radio, RadioGroup, FormControlLabel } from "@material-ui/core";
import { filterBy, orderBy, process } from "@progress/kendo-data-query";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import {
  Grid,
  GridColumn as Column,
  GridNoRecords,
} from "@progress/kendo-react-grid";
import { GridPDFExport } from "@progress/kendo-react-pdf";
import { Popup } from "@progress/kendo-react-popup";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import * as moment from "moment";
import React, { Component } from "react";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import Images from "../../Assets/Images";
import Api from "../../Services/Api";
import "../../Styles/RiskViews.scss";
import ColumnMenu from "../Dashboard/ColumnMenu";
import ColumnMenuFilter from "../Dashboard/ColumnMenuFilter";
import { CustomFieldSearchMenu } from "../Dashboard/CustomFieldSearchMenu";
import HistogramChart from "../Dashboard/HistogramChart";
import { MitigationDetails } from "../Dashboard/MitigationDetails";
import OrganizationTreeList from "../Dashboard/OrganizationTreeList";
import { SearchMenu } from "../Dashboard/SearchMenu";
import TornadoChart from "../Dashboard/TornadoChart";
import FullTornadoChart from "../Dashboard/FullTornadoChart";
import CurrencyFormat from "./Component/CurrencyFormat";
import ExistingControlCell from "./Component/ExistingControlCell";
import ImpactEditComponent from "./Component/ImpactEditComponent";
import OverallComponenant from "./Component/OverallComponenant";
import PrePostComponenant from "./Component/PrePostComponenant";
import RiskCauseCell from "./Component/RiskCauseCell";
import RiskDescriptionCell from "./Component/RiskDescriptionCell";
import StatusComponent from "./Component/StatusComponent";
import { formatNumber } from "@telerik/kendo-intl";
import QualitativeImpactEditComponent from "./Component/QualitativeImpactEditComponent";
import { mapTree } from "@progress/kendo-react-treelist";
import { ColumnMenuCheckboxFilter } from "../Dashboard/ColumnMenuCheckboxFilter";

export class MonteCarlo extends Component {
  Percentile = [
    "P5",
    "P10",
    "P15",
    "P20",
    "P25",
    "P30",
    "P35",
    "P40",
    "P45",
    "P50",
    "P55",
    "P60",
    "P65",
    "P70",
    "P75",
    "P80",
    "P85",
    "P90",
  ];

  Iteration = [100, 500, 1000, 5000, 10000];

  lastSelectedIndex = 0;
  constructor(props) {
    super(props);
    this.openSidebar = this.openSidebar.bind(this);
    this.handleOutsideClick = this.handleOutsideClick.bind(this);
    this.exportPDF = this.exportPDF.bind(this);
    this.state = {
      OrgUnitIds: [],
      riskList: [],
      riskTemp: [],
      sort: [],
      take: Math.round((window.innerHeight - 250) / 35),
      skip: 0,
      openSiderBar: false,
      riskCountMonteCarlo: {},
      aggregations: {},
      impactGridData: [],
      selectedColumn: undefined,
      customFieldsmaster: [],
      filter: {
        logic: "and",
        filters: [],
      },
      showRiskDataSet: false,
      existingFilter: [],
      riskTypemaster: [],
      actionCountMonteCarlo: {},
      riskDatasetList: [],
      HeatMapConfigDataOpportunity: [],
      HeatMapConfigDataThreat: [],
      dynamicHeatmapProbabilityRange: [],
      isCustomFieldDeleted: false,
      isImpactDeleted: false,
      notValidPrimeDataset: false,
      primeHideFlag: secureLocalStorage.getItem("isPrime") == true ? true : false,
      // Individual display options for each chart section
      preMitigatedThreatTornadoOption: "top10",
      postMitigatedThreatTornadoOption: "top10",
      unrealisedOpportunityTornadoOption: "top10",
      realisedOpportunityTornadoOption: "top10",
      preMitigatedThreatFullTornadoOption: "top10",
      postMitigatedThreatFullTornadoOption: "top10",
      unrealisedOpportunityFullTornadoOption: "top10",
      realisedOpportunityFullTornadoOption: "top10",
      chartViewOption: "combined", // Default view option for charts
    };

    this.expandChange = this.expandChange.bind(this);
    this.myRef = React.createRef();
    this.pdfExportComponent = React.createRef();
    
    // Helper functions to filter tornado data based on radio button selection
    this.getFilteredTornadoData = this.getFilteredTornadoData.bind(this);
    this.getFilteredFullTornadoData = this.getFilteredFullTornadoData.bind(this);
  }
  
  // Helper function to filter tornado data based on radio button selection
  getFilteredTornadoData(data, option) {
    if (!data) return [];
    
    // Check if data is an array
    if (!Array.isArray(data)) {
      console.error("Data is not an array:", data);
      return [];
    }
    
    // Make a deep copy to avoid modifying the original data
    const dataCopy = JSON.parse(JSON.stringify(data));
    
    // Sort the data by absolute value (magnitude) in descending order
    const sortedData = dataCopy.sort((a, b) => {
      const absA = Math.abs(parseFloat(a.value) || 0);
      const absB = Math.abs(parseFloat(b.value) || 0);
      if (absA < absB) return 1;
      if (absA > absB) return -1;
      return 0;
    });
    
    // Return all data or just the top 10 based on the option
    return option === "all" ? sortedData : sortedData.slice(0, 10);
  }
  
  // Helper function to filter full tornado data based on radio button selection
  getFilteredFullTornadoData(data, option) {
    if (!data) return [];
    
    // Check if data is an array
    if (!Array.isArray(data)) {
      console.error("Data is not an array:", data);
      return [];
    }
    
    // Make a deep copy to avoid modifying the original data
    const dataCopy = JSON.parse(JSON.stringify(data));
    
    // Sort the data by absolute value (magnitude) in descending order
    const sortedData = dataCopy.sort((a, b) => {
      const absA = Math.abs(parseFloat(a.max - a.min) || 0);
      const absB = Math.abs(parseFloat(b.max - b.min) || 0);
      if (absA < absB) return 1;
      if (absA > absB) return -1;
      return 0;
    });
    
    // Return all data or just the top 10 based on the option
    return option === "all" ? sortedData : sortedData.slice(0, 10);
  }
  componentDidMount() {
    this.isAuthorizeUse();
  }

  ToggleRiskDataset = () => {
    this.setState({ showRiskDataSet: !this.state.showRiskDataSet });
  };

  isAuthorizeUse = async () => {
    if (!secureLocalStorage.getItem("authToken")) {
      if (this.props.match.params.id) {
        this.props.history.push({
          pathname: `/tenant/${this.props.match.params.id}`,
        });
      } else {
        this.props.history.push({
          pathname: "/",
        });
      }
    } else {
      await this.getOrganizationsUnits();
      this.getRiskTypeList();
      this.getCustomField();
      this.getRiskDataSource();
      this.getMatrixColorCodes();
    }
  };

  getRiskDataSource = async () => {
    try {
      var loggedClient = secureLocalStorage.getItem("loggedClient");
      var createdby =
        loggedClient == "user"
          ? secureLocalStorage.getItem("userId")
          : secureLocalStorage.getItem("tenantId");
      var request = {
        CreatedBy: parseInt(createdby),
        Type: "Risk",
      };
      // this.setState({ ...this.state, loader: true });
      let response = await Api.getView(request);
      if (response.status == 200) {
        var datasource = response.datasource;
        this.setState({
          ...this.state,
          riskDatasetList: datasource,
          // loader: false,
        });
      } else {
        // this.setState({ ...this.state, loader: false });
      }
    } catch (error) {
      this.setState({ ...this.state, loader: false });
      console.error(error);
    }
  };
  GetSingleuser = async () => {
    var request = {
      UserId: parseInt(secureLocalStorage.getItem("loginUserId")),
    };
    this.setState({ ...this.state, loader: true });
    let response = await Api.GetSingleuser(request);
    if (response.status == 200) {
      this.setState({ ...this.state, loader: false });
      if (response.tenantUsers && response.tenantUsers.length > 0) {
        secureLocalStorage.setItem("role", response.tenantUsers[0].role);
      }
    } else {
      this.setState({ ...this.state, loader: false });
    }
  };

  getRiskTypeList = async () => {
    var typeList = [];
    try {
      let response = await Api.getRiskType();
      if (response.status === 200 && response.riskTypes) {
        for (var i = 0; i < response.riskTypes.length; i++) {
          if (response.riskTypes[i].name && response.riskTypes[i].name != "") {
            typeList.push({
              id: response.riskTypes[i].riskTypeId,
              name: response.riskTypes[i].name,
              checked: false,
              hashValue: this.convertStrToHash(response.riskTypes[i].name),
            });
          }
        }
        let newFirstElement = {
          value: "undefined",
          text: "undefined",
          id: 0,
          name: " [blank]",
          checked: false,
          hashValue: "undefined",
        };
        typeList = [newFirstElement].concat(typeList);
        this.setState({
          ...this.state,
          riskTypemaster: [...typeList],
        });
      }
      // console.clear();
    } catch (error) {
      console.error(error);
    }
  };
  getCustomField = async () => {
    let res = [];
    try {
      var request = {
        CreatedBy: parseInt(secureLocalStorage.getItem("loginUserId")),
      };

      let response = await Api.getCustomField(request);
      if (response.status == 200) {
        response.customFields.map((item) => {
          item.cfPossibleValues.map((item1) => {
            item1["hashValue"] = this.convertStrToHash(item1.possibleValues);
          });
          if (item.inputType == "Multi Drop Down") {
            let newFirstElement = {
              hashValue: "",
              id: 0,
              possibleValues: " [blank]",
            };
            item["cfPossibleValues"] = [newFirstElement].concat(
              item.cfPossibleValues
            );
            item["possibleValues"] = [" [blank]"].concat(item.possibleValues);
          }
        });
        this.setState({
          ...this.state,
          customFieldsmaster: [...response.customFields],
        });
      }
    } catch (err) {
      console.error("Exception:", err);
    }
    return res;
  };

  openSidebar(val) {
    if (!this.state.openSiderBar) {
      document.addEventListener("click", this.handleOutsideClick, false);
    } else {
      document.removeEventListener("click", this.handleOutsideClick, false);
    }
    this.setState({ ...this.state, openSiderBar: !val });
  }
  handleOutsideClick(e) {
    if (this.node.contains(e.target)) {
      return;
    }
    this.openSidebar(this.state.openSiderBar);
  }

  openQuadrantReport = async (data) => {
    await this.getRiskDataByViewId(data);
    this.setState({
      showQuadrantReport: true,
      quadrantViewData: data,
    });

    this.refs.child.refreshData();
  };

  createAppState = (dataState) => {
    if (this.state && this.state.riskTemp) {
      return {
        riskList: this.state.riskTemp.slice(0),
        dataState: dataState,
      };
    } else {
      return {
        riskList: [],
        dataState: dataState,
      };
    }
  };

  dataStateChange = (event) => {
    this.setState(this.createAppState(event.dataState));
  };

  selectionChange = (event) => {
    const data = this.state.riskList.map((item) => {
      if (item.riskRegisterId === event.dataItem.riskRegisterId) {
        item.selected = !event.dataItem.selected;
      }
      return item;
    });
    this.saveSelectedIds(data);
    this.setState({ data });
  };
  rowClick = (event) => {
    let last = this.lastSelectedIndex;
    const data = [...this.state.riskList];
    const current = data.findIndex((dataItem) => dataItem === event.dataItem);

    if (!event.nativeEvent.shiftKey) {
      this.lastSelectedIndex = last = current;
    }

    if (!event.nativeEvent.ctrlKey) {
      data.forEach((item) => (item.selected = false));
    }
    const select = !event.dataItem.selected;
    for (let i = Math.min(last, current); i <= Math.max(last, current); i++) {
      data[i].selected = select;
    }
    this.setState({ data });
  };

  saveSelectedIds = (data) => {
    let listOfIds = [];
    for (let row of Object.values(data)) {
      if (row.selected) {
        listOfIds.push(row.riskRegisterId);
      }
    }

    this.setState({ selectedIds: listOfIds }, () =>
      console.log(this.state.selectedIds)
    );
  };
  headerSelectionChange = (event) => {
    const checked = event.syntheticEvent.target.checked;
    const data = this.state.riskList.map((item) => {
      item.selected = checked;
      return item;
    });
    this.saveSelectedIds(data);
    this.setState({ data });
  };
  expandChange(event) {
    event.dataItem.expanded = event.value;
    let riskRegisterId = event.dataItem.riskRegisterId;
    this.setState({ ...this.state });
    if (!event.value || event.dataItem.mitigationResps) {
      return;
    }
    let data = this.state.riskList.slice();
    let index = data.findIndex((d) => d.riskRegisterId === riskRegisterId);
    data[index].mitigationResps = this.state.riskList.filter(
      (d) => d.riskRegisterId === riskRegisterId
    );
    this.setState({ riskList: data });
  }

  runMonteCarle = async (e) => {
    try {
      if (parseInt(this.state.Iteration) > 10000) {
        toastr.error(
          "Iteration should be less than 10,000.Because it may be time out"
        );
        return;
      }
      var request = {
        riskData: this.state.selectedIds ? this.state.selectedIds : [],
        Impact: this.state.Impact ? this.state.Impact.name : "",
        Percentile1: this.state.Percentile
          ? parseInt(this.state.Percentile.substring(1))
          : 50,
        Iteration: parseInt(this.state.Iteration),
      };
      this.setState({ ...this.state, loader: true });
      let response = await Api.runMonteCarle(request);
      if (response.status == 200) {
        this.myRef.current.scrollIntoView();
        this.setState({
          ...this.state,
          loader: false,
          //threat
          mitigatedTornodoResponse:
            response.mitigatedMonteCarloResponse.tornodoResponses,
          mitigatedHistogramResponse:
            response.mitigatedMonteCarloResponse.histogramResponse,
          nonmitigatedTornodoResponse:
            response.nonMitigatedMonteCarloResponse.tornodoResponses,
          nonmitigatedHistogramResponse:
            response.nonMitigatedMonteCarloResponse.histogramResponse,

          //oppertunities
          mitigatedTornodoResponseOpportunity:
            response.mitigatedMonteCarloResponse.tornodoOpportunityResponses,
          mitigatedHistogramResponseOpportunity:
            response.mitigatedMonteCarloResponse.histogramOpportunityResponse,

          nonmitigatedTornodoResponseOpportunity:
            response.nonMitigatedMonteCarloResponse.tornodoOpportunityResponses,
          nonmitigatedHistogramResponseOpportunity:
            response.nonMitigatedMonteCarloResponse
              .histogramOpportunityResponse,

          nonMitigatedFullTornodoResponses:
            response.nonMitigatedMonteCarloResponse
              .nonMitigatedFullTornodoResponses,
          mitigatedFullTornodoResponses:
            response.mitigatedMonteCarloResponse.mitigatedFullTornodoResponses,

          nonMitigatedOppFullTornodoResponses:
            response.nonMitigatedMonteCarloResponse
              .nonMitigatedOppFullTornodoResponses,
          mitigatedOppFullTornodoResponses:
            response.mitigatedMonteCarloResponse
              .mitigatedOppFullTornodoResponses,

          openPercentaileModelFlag: false,
        });
      } else {
        this.setState({
          ...this.state,
          loader: false,
          mitigatedTornodoResponse: [],
          mitigatedHistogramResponse: [],
          nonmitigatedTornodoResponse: [],
          nonmitigatedHistogramResponse: [],
          nonMitigatedFullTornodoResponses: [],
          mitigatedFullTornodoResponses: [],
          nonMitigatedOppFullTornodoResponses: [],
          mitigatedOppFullTornodoResponses: [],
        });
      }
    } catch (error) {
      this.setState({
        ...this.state,
        loader: false,
        mitigatedTornodoResponse: [],
        mitigatedHistogramResponse: [],
        nonmitigatedTornodoResponse: [],
        nonmitigatedHistogramResponse: [],
        nonMitigatedFullTornodoResponses: [],
        mitigatedFullTornodoResponses: [],
        nonMitigatedOppFullTornodoResponses: [],
        mitigatedOppFullTornodoResponses: [],
      });

      console.error(error);
    }
  };

  runMonteCarleForGrid = async (e) => {
    try {
      var request = {
        riskData: this.state.selectedIds ? this.state.selectedIds : [],
        Impact: this.state.Impact ? this.state.Impact.name : "",
        Percentile: this.state.Percentile
          ? parseInt(this.state.Percentile.substring(1))
          : 0,
        Iteration: parseInt(this.state.Iteration),
      };
      this.setState({ ...this.state, loader: true });
      let response = await Api.runMonteCarle(request);
      if (response.status == 200) {
        this.setState({
          ...this.state,
          loader: false,
          impactGridData: response.impactGridData,
          openPercentaileModelFlag: false,
        });
      } else {
        this.setState({
          ...this.state,
          loader: false,
          impactGridData: [],
        });
      }
    } catch (error) {
      this.setState({
        ...this.state,
        loader: false,
        impactGridData: [],
      });

      console.error(error);
    }
  };

  getOrganizationsUnits = async () => {
    try {
      var loggedClient = secureLocalStorage.getItem("loggedClient");
      var createdby =
        loggedClient == "user"
          ? secureLocalStorage.getItem("userId")
          : secureLocalStorage.getItem("tenantId");
      var request = {
        CreatedBy: parseInt(createdby),
      };
      this.setState({ ...this.state, loader: true });
      let response = await Api.getOrgUnits(request);
      if (response.status == 200) {
        this.setState({
          ...this.state,
          loader: false,
          data: response.organisationUnit,
          Iteration: 1000,
        });
      } else {
        this.setState({
          ...this.state,
          data: [],
          loader: false,
          Iteration: 1000,
        });
      }
    } catch (error) {
      this.setState({ ...this.state, loader: false });
      console.error(error);
    }
  };
  getRiskListByOrgUnitIds = async (idList) => {
    try {
      var request = {
        OrgUnitIds: idList,
      };
      this.state = { ...this.state, loader: true, viewId: 0 };
      let response = await Api.getRiskForOrgUnit(request);
      if (response.status == 200) {
        response.riskRegister.map((riskReg) => {
          if (riskReg.proximityDate) {
            riskReg.proximityDate = new Date(riskReg.proximityDate);
          }
          if (riskReg.createdDate) {
            // riskReg.createdDate = new Date(riskReg.createdDate);
            var time = moment(riskReg.createdDate).toDate();
            time.setHours(0);
            time.setMinutes(0);
            time.setSeconds(0);
            time.setMilliseconds(0);
            let createdDate = time;
            riskReg.createdDate = riskReg.createdDate
              ? new Date(createdDate)
              : "";
          }

          if (riskReg.riskTypeNames) {
            let hashArr = this.stringToHash(
              riskReg.riskTypeNames.toString(),
              "riskTypeNames"
            );
            riskReg["riskTypeNames"] = hashArr;
          } else {
            riskReg["riskTypeNames"] = "undefined";
            riskReg["riskTypeNamesExport"] = "";
          }
          if (riskReg.isClosed) {
            riskReg.isClosed = "Open";
          } else {
            riskReg.isClosed = "Closed";
          }
          if (riskReg.closedDate) {
            riskReg.closedDate = new Date(riskReg.closedDate);
          } else {
            riskReg.closedDate = null;
          }
        });
        let impactMaster = [];
        if (response.riskRegister && response.riskRegister.length > 0) {
          impactMaster = response.riskRegister[0].impactResponse;
        }
        this.setState({ ...this.state, impactMaster: impactMaster });
        // await this.constructImpactApprovalData(response.riskRegister);
        await this.createDynamicCols(response.riskRegister);
        await this.createDynamicDropdowns(response.riskRegister);
        var riskData = response.riskRegister.map((dataItem) =>
          Object.assign({ selected: true }, dataItem)
        );

        this.setState({
          ...this.state,
          riskList: riskData,
          riskTemp: riskData,
          loader: false,
          filter: {
            logic: "and",
            filters: [],
          },
        });
        this.saveSelectedIds(riskData);
      } else {
        this.setState({
          ...this.state,
          riskList: [],
          riskTemp: [],
          loader: false,
        });
      }
    } catch (error) {
      console.error(error);
    }
  };

  constructImpactApprovalData = async (riskArray) => {
    riskArray.map((risk) => {
      risk.impactResponse.map((impact) => {
        if (risk.isOpportunity && risk.isOpportunity == "Threat") {
          var totalvalue = this.countApprovalValue(
            impact.name,
            risk.mitigationResps,
            risk.isOpportunity
          );
          let approvedValue = Math.max(0, impact.value - totalvalue);
          impact["value"] = impact.value + "_" + approvedValue;
        } else if (risk.isOpportunity && risk.isOpportunity == "Opportunity") {
          var totalvalue = this.countApprovalValue(
            impact.name,
            risk.mitigationResps,
            risk.isOpportunity
          );
          //let approvedValue = Math.abs(impact.value) - Math.abs(totalvalue);
          if (totalvalue > Math.abs(impact.value)) {
            totalvalue = impact.value;
          }
          impact["value"] = impact.value + "_" + -Math.abs(totalvalue);
        }
      });
    });

    this.setState({ ...this.state, data: riskArray });
  };

  countApprovalValue = (name, mitigationArray, flag) => {
    var totalvalue = 0;
    mitigationArray.map((mitigation) => {
      if (mitigation.approved) {
        var impactObj = mitigation.impactResponse.filter(
          (item) => item.name == name
        );
        if (impactObj.length > 0) {
          var temp = impactObj[0];
          totalvalue =
            flag == "Threat"
              ? totalvalue + temp.value
              : totalvalue - temp.value;
        }
      }
    });
    return totalvalue;
  };

  getRiskCountMonteCarlo = async (ids, viewId) => {
    try {
      var request = {
        OrgUnitIds: ids,
        viewId: viewId,
      };
      // this.setState({ ...this.state, loader: true });
      let response = await Api.getRiskCountMonteCarlo(request);
      if (response.status == 200) {
        this.setState({
          ...this.state,
          // loader: false,
          riskCountMonteCarlo: response.riskCountResponses,
          actionCountMonteCarlo: response.actionCountResponse,
          aggregations: response.aggregations,
        });
      } else {
        this.setState({
          ...this.state,
          // loader: false,
          riskCountMonteCarlo: {},
          actionCountMonteCarlo: {},
          aggregations: {},
        });
      }
    } catch (error) {
      this.setState({ ...this.state, loader: false });
      console.error(error);
    }
  };

  clearAllCharts = (orgUnitListIds) => {
    this.setState({
      ...this.state,
      Impact: null,
      Percentile : "P50",
      Iteration:1000,
      //threat
      mitigatedTornodoResponse: [],
      mitigatedHistogramResponse: {},
      nonmitigatedTornodoResponse: [],
      nonmitigatedHistogramResponse: {},

      //oppertunities
      mitigatedTornodoResponseOpportunity: [],
      mitigatedHistogramResponseOpportunity: {},
      nonmitigatedTornodoResponseOpportunity: [],
      nonmitigatedHistogramResponseOpportunity: {},
      nonMitigatedFullTornodoResponses: [],
      mitigatedFullTornodoResponses: [],
      nonMitigatedOppFullTornodoResponses: [],
      mitigatedOppFullTornodoResponses: [],
      OrgUnitIds: orgUnitListIds,
      selectedIds: [],
      existingFilter: [],
      sort: [],
      riskList: [],
      riskTemp: [],
      Impact:null,
      riskCountMonteCarlo: {
        totalRiskCount: 0,
        openRiskCount: 0,
        activeRiskCount: 0,
        closedRiskCount: 0,
      },
      actionCountMonteCarlo: {
        totalActionCount: 0,
        openActionCount: 0,
        closedActionCount: 0,
      },
      aggregations: {
        unApprovedRiskBudget : 0,
        riskBudgetApproved : 0
      }
    });
  };
  getMatrixColorCodes = async () => {
    try {
      // var req = {
      //   WorkstreamId: 0,
      // };
      let response = await Api.MatrixColor();
      if (response.status === 200) {
       // normal,opportunity
       let normal_opp = response.matrixColor.find(
        (item) => item.riskType === "opportunity"
      );
      let opp_colorJsonData = JSON.parse(normal_opp.colorJsonData);

      //  normal,threat
      let normal_threat = response.matrixColor.find(
        (item) => item.riskType === "threat"
      );
      let threat_colorJsonData = JSON.parse(normal_threat.colorJsonData);
      this.setState({
        
        HeatMapConfigDataThreat: threat_colorJsonData,
        HeatMapConfigDataOpportunity: opp_colorJsonData,

        heatMapCount: response.heatmapCount,
        dynamicHeatmapProbabilityRange:
          response.dynamicHeatmapProbabilityRange,
      });
      }
    } catch (error) {
      console.error(error);
    }
  };
  getRiskList = async (orgUnitListIds) => {
    if (orgUnitListIds && orgUnitListIds.length > 0) {
      // let primeHideFlag = secureLocalStorage.getItem("isPrime")==true?true:false;
      // if(primeHideFlag){
      //   let arr=[];
      //   mapTree(this.state.data, "children", (item) => {
      //     if (orgUnitListIds.includes(item.unitId)) {
      //       if (item.isPrime) {
      //         primeHideFlag = item.isPrime;
      //         arr.push(true);
      //       }
      //     }
      //     return item;
      //   });
      //   primeHideFlag=arr.includes(true)?true:false;
      // }
      let primeHideFlag =
        secureLocalStorage.getItem("isPrime") == true ? true : false;
      mapTree(this.state.data, "children", (item) => {
        if (orgUnitListIds.includes(item.unitId)) {
          if (!item.isPrime) {
            primeHideFlag = item.isPrime;
          }
        }
        return item;
      });
      this.getRiskListByOrgUnitIds(orgUnitListIds, 0);
      this.getRiskCountMonteCarlo(orgUnitListIds);
      // this.clearAllCharts(orgUnitListIds);
      this.getImpactList(orgUnitListIds);
      this.setState({
        ...this.state,
        primeHideFlag: primeHideFlag,
        Impact: null,
        //threat
        mitigatedTornodoResponse: [],
        mitigatedHistogramResponse: {},
        nonmitigatedTornodoResponse: [],
        nonmitigatedHistogramResponse: {},

        //oppertunities
        mitigatedTornodoResponseOpportunity: [],
        mitigatedHistogramResponseOpportunity: {},
        nonmitigatedTornodoResponseOpportunity: [],
        nonmitigatedHistogramResponseOpportunity: {},
        nonMitigatedFullTornodoResponses: [],
        mitigatedFullTornodoResponses: [],
        nonMitigatedOppFullTornodoResponses: [],
        mitigatedOppFullTornodoResponses: [],
        OrgUnitIds: orgUnitListIds,
        selectedIds: [],
        existingFilter: [],
        sort: [],
        riskList: [],
        riskTemp: [],
        riskCountMonteCarlo: {
          totalRiskCount: 0,
          openRiskCount: 0,
          activeRiskCount: 0,
          closedRiskCount: 0,
        },
        actionCountMonteCarlo: {
          totalActionCount: 0,
          openActionCount: 0,
          closedActionCount: 0,
        },
        aggregations: {
        unApprovedRiskBudget : 0,
        riskBudgetApproved : 0
        },
      });
    }
  };

  setEmptyRiskList = async (ids) => {
    this.clearAllCharts([]);
  };

  createDynamicDropdowns = async (products, filter) => {
    let dropdownColumn = [];
    products.map((res, i) => {
      res.customFields.map((item, j) => {
        if (dropdownColumn.length > 0) {
          if (!dropdownColumn.find((cf) => cf.fieldName == item.fieldName)) {
            dropdownColumn.push({
              fieldName: item.fieldName,
              data: this.getCustomFieldMasterData(item.fieldName, filter),
              inputType: this.getInputType(item.fieldName),
            });
          }
        } else {
          dropdownColumn.push({
            fieldName: item.fieldName,
            data: this.getCustomFieldMasterData(item.fieldName, filter),
            inputType: this.getInputType(item.fieldName),
          });
        }
      });
    });

    if (dropdownColumn.length > 0) {
      products.map((res) => {
        dropdownColumn.map((col) => {
          let temp = res.customFields.find(
            (item) => item.fieldName === col.fieldName
          );
          if (temp) {
            if (temp.inputType === "Multi Drop Down") {
              let val = temp.selectedCustomFieldNames
                ? temp.selectedCustomFieldNames.toString()
                : "";
              let hashArr = this.stringToHashForCF(val, col.data);
              res[col.fieldName] = hashArr;
            } else if (temp.inputType === "Single Drop Down") {
              let val = temp.selectedCustomFieldNames
                ? temp.selectedCustomFieldNames.toString()
                : "";
              res[col.fieldName] = val;
            } else if (temp.inputType === "Free Text") {
              let val = temp.multiText ? temp.multiText : "";
              res[col.fieldName] = val;
            } else if (temp.inputType === "Numeric") {
              let val = temp.multiText ? parseInt(temp.multiText) : "";
              res[col.fieldName] = val;
            } else if (temp.inputType === "Date") {
              let val = temp.multiText ? new Date(temp.multiText) : "";
              res[col.fieldName] = val;
            }
          } else {
            res[col.fieldName] = "";
          }
        });
      });
    }
    let columnsToShow = [];
    if (dropdownColumn.length > 0) {
      columnsToShow = dropdownColumn.map((item) => (
        <Column
          field={item.fieldName}
          title={item.fieldName}
          width="150px"
          cell={(props) => this.viewMultiselectColsCustomDropdown(props, item)}
          columnMenu={(props) => this.getCustomFieldColumnMenu(props, item)}
          filter={this.getCustomFieldFilter(item)}
          headerClassName={this.checkItsinFilterOrNot(item.fieldName, filter)}
        />
      ));
    }
    this.setState({ ...this.state, dropdownColumns: columnsToShow });
  };

  getCustomFieldFilter = (item) => {
    if (item.inputType === "Multi Drop Down") {
      return "";
    } else if (item.inputType === "Single Drop Down") {
      return "text";
    } else if (item.inputType === "Free Text") {
      return "";
    } else if (item.inputType === "Numeric") {
      return "numeric";
    } else if (item.inputType === "Date") {
      return "date";
    } else {
      return "";
    }
  };
  getcustomfieldlist=(list)=>{
    var sorted_arr =  list.sort(function (a, b) {
      if (a.name < b.name) {
        return -1;
      }
      if (a.name > b.name) {
        return 1;
      }
      return 0;
    });
    return sorted_arr
  }
  
  getCustomFieldColumnMenu = (props, item) => {
    if (item.inputType === "Multi Drop Down") {
      this.getcustomfieldfilterlist(item.data);
      return (
        <CustomFieldSearchMenu
          {...props}
          customFieldsmaster={item.data}
          existingFilter={this.state.existingFilter}
          filterChangeV={this.filterChangeV}
          clearFilter={this.clearFilter}
        />
      );
    }else if(item.inputType === "Single Drop Down"){
      return (                      
        <ColumnMenuCheckboxFilter
          {...props}
          data={this.state.riskList}
          getSelectedColumn={this.getSelectedColumn}
        />
      )
    } else {
      return (
        <ColumnMenuFilter
          {...props}
          getSelectedColumn={this.getSelectedColumn}
        />
      );
    }
  };

  getInputType = (fieldName) => {
    try {
      let arr = this.state.customFieldsmaster.find(
        (item) => item.fieldName == fieldName
      );
      if (arr) {
        return arr.inputType;
      } else {
        return undefined;
      }
    } catch (err) {
      console.log(err);
    }
  };

  //Impacts

  createDynamicCols = async (products, filter) => {
    let impactColumn = [];

    products.map((res, i) => {
      if (res.impactResponse) {
        res.impactResponse.map((item, j) => {
          if (impactColumn.length > 0) {
            if (!impactColumn.find((cf) => cf.fieldName == item.fieldName)) {
              impactColumn.push({
                fieldName: item.name + "_" + item.type,
                impactType: item.impactType,
              });
            }
          } else {
            impactColumn.push({
              fieldName: item.name + "_" + item.type,
              impactType: item.impactType,
            });
          }
        });
      }
    });
    // impactColumn.sort();
    // impactColumn.reverse();
    impactColumn = impactColumn.filter(
      (ele, ind) =>
        ind ===
        impactColumn.findIndex(
          (elem) =>
            elem.fieldName === ele.fieldName &&
            elem.impactType === ele.impactType
        )
    );

    if (impactColumn.length > 0) {
      products.map((res) => {
        impactColumn.map((col) => {
        if (col.impactType == "Qualitative") {
            let temp = res.impactResponse && res.impactResponse.find(
              (item) => item.name + "_" + item.type === col.fieldName
            );
            if (temp&&temp.type == "Post") {
              res[col.fieldName] =  temp.postQvalue;
            }else if (temp&&temp.type == "Pre"){
              res[col.fieldName] =temp.qValue;
            }else if (temp&&temp.type == "Current"){
              res[col.fieldName] =temp.currentQvalue;
            } else {
              res[col.fieldName] = 0;
            }
          } else {
            let temp = res.impactResponse && res.impactResponse.find(
              (item) => item.name + "_" + item.type === col.fieldName
            );
            if (temp&&temp.type == "Post") {
              res[col.fieldName] =  temp.postImpactValue;
            }else if (temp&&temp.type == "Pre"){
              res[col.fieldName] = temp.value;
            }else if (temp&&temp.type == "Current"){
              res[col.fieldName] = temp.currentImpactValue;
            } else {
              res[col.fieldName] = 0;
            }
          }
        });
      });
    }

    let columnsToShow = [];
    if (impactColumn.length > 0) {
      columnsToShow = impactColumn.map((item) => (
        <Column
          field={item.fieldName}
          title={this.getImpactUnit(item)}
          width="100px"
          editable={false}
          cell={(props) => this.getImpactCellComponent(props, item)}
          // cell={(props) => (
          //   <ImpactEditComponent {...props} onEditCell={this.onEditCell} />
          // )}
          filter={"numeric"}
          columnMenu={(props) => (
            <ColumnMenuFilter
              {...props}
              getSelectedColumn={this.getSelectedColumn}
            />
          )}
          headerClassName={this.checkItsinFilterOrNot(item.fieldName, filter)}
        />
      ));
    }
    this.setState({ ...this.state, impactColumns: columnsToShow });
  };

  getImpactCellComponent = (props, impact) => {
    if (impact.impactType == "Qualitative") {
      return (
        <QualitativeImpactEditComponent
          {...props}
          onEditCell={this.onEditCell}
        />
      );
    } else {
      return <ImpactEditComponent {...props} onEditCell={this.onEditCell} />;
    }
  };

  getImpactUnit = (impact) => {
    if (impact.impactType == "Qualitative") {
      var impactTemp = this.state.impactMaster.find(
        (item) => item.name + "_" + item.type == impact.fieldName
      );
      var res = impact.fieldName;
      if (impactTemp && impactTemp.name) {
        res = impactTemp.name + " / " + " (" + impactTemp.type + ")";
      }
      return res;
    } else {
      var impactTemp = this.state.impactMaster.find(
        (item) => item.name + "_" + item.type == impact.fieldName
      );
      var res = impact.fieldName;
      if (impactTemp && impactTemp.name) {
        res =
          impactTemp.name +
          " / " +
          impactTemp.units +
          " (" +
          impactTemp.type +
          ")";
      }
      return res;
    }
  };

  numericCellEdit = (dataItem, field, riskData) => {};
  handleViewName = (e) => {
    // if (e.target.value.match("^[a-zA-Z]*$") != null) {
    this.setState({
      ...this.state,
      Name: e.target.value,
    });
    // }
  };

  getImpactList = async (id) => {
    try {
      // this.setState({ ...this.state, loader: true });
      let req = {
        OrgUnitIds: id,
      };
      let response = await Api.getImpactsByWorkstream(req);
      if (response.status === 200 && response.impacts) {
        this.setState({
          ...this.state,
          // loader: false,
          impactslist: response.impacts,
        });
      } else {
        this.setState({ ...this.state, impactslist: [] });
      }
    } catch (error) {
      this.setState({ ...this.state, loader: false });
      console.error(error);
    }
  };

  openPercentailePopup = () => {
    this.setState({
      ...this.state,
      openPercentaileModelFlag: true,
    });
  };
  closePercentailePopup = () => {
    this.setState({
      ...this.state,
      openPercentaileModelFlag: false,
    });
  };

  //  exportPDFWithComponent = () => {
  //   if (this.pdfExportComponent.current) {
  //     this.pdfExportComponent.current.save();
  //   }
  // };

  gridPDFExport;
  exportPDF = async () => {
    // setTimeout(() => {
    //   this.gridPDFExport.save(this.state.riskList);
    // }, 250);
    this.exportMontecarloPdf();
  };

  exportMontecarloPdf = () => {
    this.setState({ ...this.state, loader: true });
    const CreatedDate = moment(new Date()).format("DD-MMM-yyyy");
    html2canvas(document.querySelector("#capture")).then((canvas) => {
      // document.body.appendChild(canvas); // if you want see your screenshot in body.
      const imgData = canvas.toDataURL("image/png");
      var doc = new jsPDF("p", "mm", "a4");
      var width = doc.internal.pageSize.getWidth();
      var height = doc.internal.pageSize.getHeight();
      doc.addImage(imgData, "JPEG", 0, 0, width, height);
      doc.setProperties({
        title: "Monte Carlo Report_" + CreatedDate,
        subject: "This is the report for montecarlo",
        author: "Riskwell Team",
        // keywords: 'generated, ',
        creator: "Riskwell Team",
        // description:'description test'
      });
      // Output as Data URI
      // doc.output('datauri');
      doc.save("Histogram_and_tornado.pdf");
      this.setState({ ...this.state, loader: false });
    });
  };

  onEditCell = () => {};

  sortChange = (event) => {
    this.setState({
      riskList: this.getProducts(event.sort),
      sort: event.sort,
    });
  };
  getProducts = (sort) => {
    return orderBy(this.state.riskList, sort);
  };
  pageChange = (event) => {
    this.setState({
      skip: event.page.skip,
      take: event.page.take,
    });
  };

  getCustomFieldMasterData = (fieldName, filter) => {
    try {
      let arr = this.state.customFieldsmaster.filter(
        (item) => item.fieldName === fieldName
      );
      if (arr && arr.length > 0) {
        let temp = [];
        arr[0].cfPossibleValues.map((item, index) => {
          let checked = this.checkCFinFilterValuesOrNot(
            fieldName,
            item.hashValue,
            filter
          );
          temp.push({
            id: index,
            name: item.possibleValues,
            checked: checked,
            hashValue: item.hashValue, //this.convertStrToHash(item),
          });
        });
        return temp;
      } else {
        return [];
      }
    } catch (err) {
      return [];
    }
  };
  checkRisktypeSelections = (exfilter) => {
    let temp = [];
    this.state.riskTypemaster.map((item) => {
      let checked = this.checkCFinFilterValuesOrNot(
        "riskTypeNames",
        item.hashValue,
        exfilter
      );
      item["checked"] = checked;
      temp.push(item);
    });
    this.setState({ ...this.state, riskTypemaster: temp });
  };
  checkItsinFilterOrNot = (field, exfilter) => {
    try {
      let headerClassName = "";
      if (exfilter) {
        exfilter.map((filter) => {
          if (filter.field === field) {
            headerClassName = "active";
          }
          if (filter.filters) {
            filter.filters.map((innerFilter) => {
              if (innerFilter.field === field) {
                headerClassName = "active";
              }
            });
          }
        });
        return headerClassName;
      }
    } catch (err) {}
  };
  checkCFinFilterValuesOrNot = (field, value, exfilter) => {
    let flag = false;
    try {
      if (exfilter) {
        exfilter.map((filter) => {
          if (filter.field === field && filter.value == value) {
            flag = true;
          }
          if (filter.filters) {
            filter.filters.map((innerFilter) => {
              if (innerFilter.field === field && innerFilter.value == value) {
                flag = true;
              }
            });
          }
        });
      }
    } catch (err) {
      return flag;
    }
    return flag;
  };
  stringToHash(stringArr, cols) {
    let hashArr = [];

    if (stringArr && stringArr.includes(",")) {
      let valArr = stringArr.split(",");
      if (cols == "riskTypeNames") {
        valArr &&
          valArr.map((item1) => {
            let risktype = this.state.riskTypemaster.find(
              (item) => item.name == item1
            );
            if (risktype) {
              hashArr.push(risktype.hashValue);
            }
          });
      }
    } else {
      if (stringArr != "") {
        if (cols == "riskTypeNames") {
          let risktype = this.state.riskTypemaster.find(
            (item) => item.name == stringArr
          );
          if (risktype) {
            hashArr.push(risktype.hashValue);
          }
        }
      }
    }

    return hashArr.toString();
  }
  convertStrToHash = (str) => {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
      let char = str.charCodeAt(i);
      hash = (hash << 5) - hash + char;
      hash = hash & hash;
    }
    hash = Math.abs(hash).toString();
    return hash;
  };

  stringToHashForCF(stringArr, data) {
    let hashArr = [];
    if (stringArr && stringArr.includes(",")) {
      let valArr = stringArr.split(",");
      valArr &&
        valArr.map((item1) => {
          let cfVal = data.find((item) => item.name == item1);
          if (cfVal) {
            hashArr.push(cfVal.hashValue);
          }
        });
    } else {
      let cfVal = data.find((item) => item.name == stringArr);
      if (cfVal) {
        hashArr.push(cfVal.hashValue);
      }
    }
    return hashArr.toString();
  }
  filterChangeExisting = async (e) => {
    if (e.nativeEvent.type == "submit") {
      let existingFilter = this.state.existingFilter
        ? this.state.existingFilter
        : [];
      let filter = e.filter ? e.filter.filters : [];

      // Get the field being filtered from the new filter
      const newFilterFields = new Set();
      if (filter && filter.length > 0) {
        filter.forEach(filterItem => {
          if (filterItem.filters) {
            filterItem.filters.forEach(innerFilter => {
              if (innerFilter.field) {
                newFilterFields.add(innerFilter.field);
              }
            });
          } else if (filterItem.field) {
            newFilterFields.add(filterItem.field);
          }
        });
      }

      // Remove any existing filters for the same fields
      let filteredExisting = existingFilter.filter(item => {
        // For filters with nested filters array
        if (item.filters) {
          return !item.filters.some(innerFilter =>
            innerFilter.field && newFilterFields.has(innerFilter.field)
          );
        }
        // For direct filters
        return !(item.field && newFilterFields.has(item.field));
      });

      // Combine filtered existing filters with new filters
      let combinedFilters = [...filteredExisting, ...filter];

      // Deduplicate the combined filters
      const uniqueFilters = new Set();
      const dedupedFilters = [];

      for (const filterItem of combinedFilters) {
        const filterStr = JSON.stringify(filterItem);
        if (!uniqueFilters.has(filterStr)) {
          uniqueFilters.add(filterStr);
          dedupedFilters.push(filterItem);
        }
      }
      existingFilter = dedupedFilters;
      const result = filterBy(this.state.riskTemp, dedupedFilters);
      if (result && result.length > 0) {
        await this.createDynamicDropdowns(result, dedupedFilters);
        await this.createDynamicCols(result, dedupedFilters);
        await this.checkRisktypeSelections(dedupedFilters);
      }
      var riskData = result.map((dataItem) =>
        Object.assign({ selected: true }, dataItem)
      );

      this.setState({
        ...this.state,
        riskList: riskData,
        existingFilter: dedupedFilters,
        take: Math.round((window.innerHeight - 250) / 35),
        skip: 0,
        filter: e.filter,
      });
      this.saveSelectedIds(riskData);
    } else if (e.nativeEvent.type == "reset") {
      let exi = [];
      if (this.state.existingFilter) {
        let filterData = this.state.existingFilter;
        filterData.forEach((filter2) => {
          if (filter2.filters) {
            // Only add the filter if none of its inner filters match the selected column
            const hasMatchingInnerFilter = filter2.filters.some(
              innerFilter => innerFilter.field === this.state.selectedColumn
            );
            if (!hasMatchingInnerFilter) {
              exi.push(filter2);
            }
          } else {
            if (filter2.field != this.state.selectedColumn) {
              exi.push(filter2);
            }
          }
        });
      }
      const result = filterBy(this.state.riskTemp, exi);
      await this.createDynamicDropdowns(result, exi);
      await this.createDynamicCols(result, exi);
      await this.checkRisktypeSelections(exi);
      var riskData = result.map((dataItem) =>
        Object.assign({ selected: true }, dataItem)
      );

      this.setState({
        ...this.state,
        riskList: riskData,
        existingFilter: exi,
        take: Math.round((window.innerHeight - 250) / 35),
        skip: 0,
        filter: e.filter,
      });
      this.saveSelectedIds(riskData);
    }
  };
  getSelectedColumn = (col) => {
    if (col != this.state.selectedColumn) {
      this.setState({ ...this.state, selectedColumn: col });
    }
  };

  filterChangeV = async (e, colname) => {
    let exi = []; //this.state.existingFilter;
    if (this.state.existingFilter) {
      let filterData = this.state.existingFilter;
      filterData.map((filter2) => {
        if (filter2.filters) {
          filter2.filters.map((innerFilter) => {
            if (innerFilter.field != colname) {
              exi.push(filter2);
            }
          });
        } else {
          if (filter2.field != colname) {
            exi.push(filter2);
          }
        }
      });
    }

    let filter = e ? e.filters : [];
    let temp = [];
    if (filter.length > 0) {
      temp = [
        {
          filters: filter,
          logic: "or",
        },
      ];
    }

    let arr = [...exi, ...temp];

    const result = filterBy(this.state.riskTemp, arr);
    if (result && result.length > 0) {
    await this.createDynamicDropdowns(result, arr);
    await this.createDynamicCols(result, arr);
    await this.checkRisktypeSelections(arr);
    }
    var riskData = result.map((dataItem) =>
      Object.assign({ selected: true }, dataItem)
    );
    this.setState({
      ...this.state,
      riskList: riskData,
      existingFilter: arr,
      take: Math.round((window.innerHeight - 250) / 35),
      skip: 0,
      filter: {
        logic: "and",
        filters: arr,
      },
    });
    this.saveSelectedIds(riskData);
  };
  clearFilter = (e) => {
    let filter = e ? e : [];
    const result = filterBy(this.state.riskTemp, filter);
    this.createDynamicDropdowns(result, filter);
    this.createDynamicCols(result, filter);
    this.checkRisktypeSelections(filter);
    var riskData = result.map((dataItem) =>
      Object.assign({ selected: true }, dataItem)
    );
    this.setState({
      ...this.state,
      riskList: riskData,
      existingFilter: filter,
      take: Math.round((window.innerHeight - 250) / 35),
      skip: 0,
      filter: {
        logic: "and",
        filters: filter,
      },
    });
    this.saveSelectedIds(riskData);
  };
  viewMultiselectColsCustomDropdown = (event, cfObj) => {
    let data = cfObj.data;
    let value = event.dataItem[event.field];

    if (cfObj && cfObj.inputType === "Multi Drop Down") {
      let temp = [];
      if (value && value.includes(",")) {
        let arr = value.split(",");
        arr &&
          arr.map((item1, i) => {
            let originalValue = data.find((item) => item.hashValue === item1);
            if (originalValue) {
              temp.push(originalValue.name);
            }
          });
      } else {
        let originalValue = data.find((item) => item.hashValue === value);
        if (originalValue && originalValue.name != " [blank]") {
          temp.push(originalValue.name);
        }
      }
      return <td title={temp.toString()}>{temp.toString()}</td>;
    } else if (cfObj && cfObj.inputType === "Single Drop Down") {
      return (
        <td title={value ? value.toString() : ""}>
          {value ? value.toString() : ""}
        </td>
      );
    } else if (cfObj && cfObj.inputType === "Free Text") {
      return (
        <td title={value ? value.toString() : ""}>
          {value ? value.toString() : ""}
        </td>
      );
    } else if (cfObj && cfObj.inputType === "Numeric") {
      return (
        <td
          title={
            value || value === 0 ? formatNumber(parseInt(value), "##,#") : ""
          }
        >
          {value || value === 0 ? formatNumber(parseInt(value), "##,#") : ""}
        </td>
      );
    } else if (cfObj && cfObj.inputType === "Date") {
      return (
        <td title={value ? moment(value).format("DD-MMM-YYYY") : ""}>
          {value ? moment(value).format("DD-MMM-YYYY") : ""}
        </td>
      );
    } else {
      return <td></td>;
    }
  };

  viewMultiselectColsRiskType = (event) => {
    let value = event.dataItem[event.field];
    let temp = [];

    if (value && value.includes(",")) {
      let arr = value.split(",");
      arr &&
        arr.map((item1, i) => {
          let originalValue = this.state.riskTypemaster.find(
            (item) => item.hashValue == item1
          );
          if (originalValue) {
            temp.push(originalValue.name);
          }
        });
    } else {
      let originalValue = this.state.riskTypemaster.find(
        (item) => item.hashValue == value
      );
      if (originalValue && originalValue.name != " [blank]") {
        temp.push(originalValue.name);
      }
    }
    return <td title={temp.toString()}>{temp.toString()}</td>;
  };
  getsortedrisklist=()=>{
    let sorted_arr =  this.state.riskTypemaster.sort(function (a, b) {
      if (a.name < b.name) {
        return -1;
      }
      if (a.name > b.name) {
        return 1;
      }
      return 0;
    });
  }
  selectViewAction = async (data) => {
    let primeHideFlag =
      secureLocalStorage.getItem("isPrime") == true ? true : false;
    mapTree(this.state.data, "children", (item) => {
      if (this.state.OrgUnitIds.includes(item.unitId)) {
        if (!item.isPrime) {
          primeHideFlag = item.isPrime;
        }
      }
      return item;
    });
    await this.getRiskDataByViewId(data);
    this.setState({
      ...this.state,
      viewId: data.id,
      primeHideFlag: primeHideFlag,
      Impact:null,
      //threat
      mitigatedTornodoResponse: [],
      mitigatedHistogramResponse: {},
      nonmitigatedTornodoResponse: [],
      nonmitigatedHistogramResponse: {},

      //oppertunities
      mitigatedTornodoResponseOpportunity: [],
      mitigatedHistogramResponseOpportunity: {},
      nonmitigatedTornodoResponseOpportunity: [],
      nonmitigatedHistogramResponseOpportunity: {},
      nonMitigatedFullTornodoResponses: [],
      mitigatedFullTornodoResponses: [],
      nonMitigatedOppFullTornodoResponses: [],
      mitigatedOppFullTornodoResponses: [],

      // selectedIds: [],
      // existingFilter: [],
      // sort: [],
      // riskList: [],
      // riskTemp: [],
      // riskCountMonteCarlo: {
      //   totalRiskCount: 0,
      //   openRiskCount: 0,
      //   activeRiskCount: 0,
      //   closedRiskCount: 0,
      // },
      // actionCountMonteCarlo: {
      //   totalActionCount: 0,
      //   openActionCount: 0,
      //   closedActionCount: 0,
      // },
    });
  };
  getRiskDataByViewId = async (viewData) => {
    try {
      var loggedClient = secureLocalStorage.getItem("loggedClient");
      var createdby =
        loggedClient == "user"
          ? secureLocalStorage.getItem("userId")
          : secureLocalStorage.getItem("tenantId");
      const requestParams = {
        ViewId: viewData.id,
        CreatedBy: parseInt(createdby),
      };
      this.setState({
        ...this.state,
        loader: true,
        viewType: "RISK",
        take: Math.round((window.innerHeight - 250) / 35),
        skip: 0,
        existingFilter: [],
        filter: {
          logic: "and",
          filters: [],
        },
      });
      let result = await Api.getByViewId(requestParams);
      if (result.status == 200) {
        if (
          result.isCustomFieldDeleted ||
          result.isImpactDeleted ||
          result.notValidPrimeDataset
        ) {
          this.setState({
            ...this.state,
            riskList: [],
            selectedOrgUnit: [],
            riskTemp: [],
            loader: false,
            isCustomFieldDeleted: result.isCustomFieldDeleted,
            isImpactDeleted: result.isImpactDeleted,
            notValidPrimeDataset: result.notValidPrimeDataset,
          });
          return;
        }

        let response = result;
        var selectedOrgUnitArray = [];
        response.riskRegister.map((riskReg) => {
          if (riskReg.proximityDate) {
            riskReg.proximityDate = new Date(riskReg.proximityDate);
          }
          if (riskReg.createdDate) {
            riskReg.createdDate = new Date(riskReg.createdDate);
          }
          selectedOrgUnitArray.push(riskReg.organizationUnitId);

          if (riskReg.riskTypeNames) {
            let hashArr = this.stringToHash(
              riskReg.riskTypeNames.toString(),
              "riskTypeNames"
            );

            riskReg["riskTypeNames"] = hashArr;
          } else {
            riskReg["riskTypeNames"] = "undefined";
            riskReg["riskTypeNamesExport"] = "";
          }
          if (riskReg.isClosed) {
            riskReg.isClosed = "Open";
          } else {
            riskReg.isClosed = "Closed";
          }
          if (riskReg.closedDate) {
            riskReg.closedDate = new Date(riskReg.closedDate);
          } else {
            riskReg.closedDate = null;
          }
        });
        let impactMaster = [];
        if (response.riskRegister && response.riskRegister.length > 0) {
          impactMaster = response.riskRegister[0].impactResponse;
        }
        this.setState({ ...this.state, impactMaster: impactMaster });
        // await this.constructImpactApprovalData(response.riskRegister);
        await this.createDynamicCols(response.riskRegister);
        await this.createDynamicDropdowns(response.riskRegister);
        this.setState({
          ...this.state,
          selectedOrgUnit: selectedOrgUnitArray,
          OrgUnitIds: Array.from(new Set(selectedOrgUnitArray)),
          riskTemp: response.riskRegister,
          loader: false,
        });
        var riskData = response.riskRegister.map((dataItem) =>
          Object.assign({ selected: true }, dataItem)
        );
        this.setState({
          ...this.state,
          riskList: riskData,
        });
        this.refs.child.refreshData(Array.from(new Set(selectedOrgUnitArray)));
        this.getRiskCountMonteCarlo(
          Array.from(new Set(selectedOrgUnitArray)),
          viewData.id
        );
        this.saveSelectedIds(riskData);
        this.getImpactList(Array.from(new Set(selectedOrgUnitArray)));
      } else {
        this.refs.child.refreshData([]);
        this.getRiskCountMonteCarlo([]);

        this.setState({
          ...this.state,
          riskList: [],
          selectedOrgUnit: [],
          riskTemp: [],
          loader: false,
        });
      }
    } catch (error) {
      console.log(error);
      this.setState({ ...this.state, loader: false });
    }
  };
  refreshPage = () => {
    window.location.reload();
  };

  setClassName = (field) => {
    let headerClassName = "";
    if (this.state.filter && this.state.filter.filters) {
      this.state.filter.filters.map((filter) => {
        if (filter.field === field) {
          headerClassName = "active";
        }
        if (filter.filters) {
          filter.filters.map((innerFilter) => {
            if (innerFilter.field === field) {
              headerClassName = "active";
            }
          });
        }
      });
    }
    return headerClassName;
  };
  render() {
    const CreatedDate = moment(new Date()).format("DD-MMM-yyyy");
    let isPrime = this.state.primeHideFlag;

    const grid = (
      <Grid
        style={{ minHeight: "100px" }}
        // data={process(this.state.riskList, this.state.dataState)}
        data={filterBy(this.state.riskList, this.state.filter).slice(
          this.state.skip,
          this.state.take + this.state.skip
        )}
        reorderable
        resizable
        expandField="expanded"
        onExpandChange={this.expandChange}
        detail={MitigationDetails}
        {...this.state.dataState}
        onDataStateChange={this.dataStateChange}
        selectedField="selected"
        onSelectionChange={this.selectionChange}
        onHeaderSelectionChange={this.headerSelectionChange}
        pageable={true}
        sortable={{
          allowUnsort: true,
          mode: "multiple",
        }}
        sort={this.state.sort}
        onSortChange={this.sortChange}
        total={filterBy(this.state.riskList, this.state.filter).length}
        skip={this.state.skip}
        take={this.state.take}
        onPageChange={this.pageChange}
        onFilterChange={this.filterChangeExisting}
        filter={this.state.filter}
      >
        <GridNoRecords>
          {this.state.notValidPrimeDataset
            ? "Cannot load dataset as Prime settings have been changed for Tenant or Workstream"
            : this.state.isCustomFieldDeleted
            ? "Associated Dataset's Custom fields might been deleted or revoked"
            : this.state.isImpactDeleted
            ? "Associated Dataset's Impact fields might been deleted or revoked"
            : "No records available"}
        </GridNoRecords>

        <Column
          field="selected"
          locked={true}
          width="42px"
          headerSelectionValue={
            this.state.riskList.findIndex(
              (dataItem) => dataItem.selected === false
            ) === -1
          }
        />
        <Column
          field="organizationUnitName"
          title="Workstream"
          width="100px"
          columnMenu={(props) => (
            <ColumnMenuFilter
              {...props}
              getSelectedColumn={this.getSelectedColumn}
            />
          )}
          headerClassName={this.setClassName("organizationUnitName")}
        />
        
        <Column
          field="riskTitle"
          title="Risk Title*"
          width="150px"
          locked={true}
          columnMenu={(props) => (
            <ColumnMenuFilter
              {...props}
              getSelectedColumn={this.getSelectedColumn}
            />
          )}
          headerClassName={this.setClassName("riskTitle")}
        />
        <Column
          field="name"
          title="Risk Description"
          width="80px"
          editable={false}
          cell={(props) => <RiskDescriptionCell {...props} />}
          columnMenu={(props) => (
            <ColumnMenuFilter
              {...props}
              getSelectedColumn={this.getSelectedColumn}
            />
          )}
          headerClassName={this.setClassName("name")}
        />
        <Column
          field="isOpportunity"
          title="T/O"
          width="150px"
          cell={(props) =>
            props.dataItem.isOpportunity === "Threat" ? (
              <td>{props.dataItem.isOpportunity}</td>
            ) : (
              <td>
                <span className="turquoiseBlue">
                  {props.dataItem.isOpportunity}
                </span>
              </td>
            )
          }
          columnMenu={(props) => (
            <ColumnMenuCheckboxFilter
              {...props}
              data={this.state.riskList}
              getSelectedColumn={this.getSelectedColumn}
            />
          )}
          headerClassName={this.setClassName("isOpportunity")}
        />
        <Column
          field="number"
          title="Risk Number"
          width="100px"
          columnMenu={(props) => (
            <ColumnMenuFilter
              {...props}
              getSelectedColumn={this.getSelectedColumn}
            />
          )}
          headerClassName={this.setClassName("number")}
        />
{this.getsortedrisklist()}
        <Column
          field="riskTypeNames"
          title="Risk Type"
          width="150px"
          cell={this.viewMultiselectColsRiskType}
          columnMenu={(props) => (
            <SearchMenu
              {...props}
              existingFilter={this.state.existingFilter}
              data={this.state.riskTypemaster}
              filterChangeV={this.filterChangeV}
              clearFilter={this.clearFilter}
            />
          )}
          headerClassName={this.setClassName("riskTypeNames")}
        />

        {this.state.dropdownColumns}
        <Column
          field="cause"
          title="Cause"
          width="100px"
          editable={false}
          cell={(props) => <RiskCauseCell {...props} />}
          columnMenu={(props) => (
            <ColumnMenuFilter
              {...props}
              getSelectedColumn={this.getSelectedColumn}
            />
          )}
          headerClassName={this.setClassName("cause")}
        />
        <Column
          field="existingControl"
          title="Existing Control"
          width="100px"
          editable={false}
          cell={(props) => <ExistingControlCell {...props} />}
          columnMenu={(props) => (
            <ColumnMenuFilter
              {...props}
              getSelectedColumn={this.getSelectedColumn}
            />
          )}
          headerClassName={this.setClassName("existingControl")}
        />
        <Column
          field="frequency"
          title="Pre-Probability (%)"
          width="80px"
          filter={"numeric"}
          columnMenu={(props) => (
            <ColumnMenuFilter
              {...props}
              getSelectedColumn={this.getSelectedColumn}
            />
          )}
          headerClassName={this.setClassName("frequency")}
        />

        <Column
          field="currentProbability"
          title="Current Probability (%)"
          width="80px"
          editable={false}
          cell={(props) => (
            <td>
              <span className="turquoiseBlue">
                {props.dataItem.currentProbability}
              </span>
            </td>
          )}
          columnMenu={(props) => (
            <ColumnMenuFilter
              {...props}
              getSelectedColumn={this.getSelectedColumn}
            />
          )}
          headerClassName={this.setClassName("currentProbability")}
        />
        <Column
          field="reductionProbability"
          title="Post-Probability (%)"
          width="75px"
          editable={false}
          cell={(props) => (
            <td>
              <span className="yellowCell">
                {props.dataItem.reductionProbability}
              </span>
            </td>
          )}
          filter={"numeric"}
          columnMenu={(props) => (
            <ColumnMenuFilter
              {...props}
              getSelectedColumn={this.getSelectedColumn}
            />
          )}
          headerClassName={this.setClassName("reductionProbability")}
        />
        <Column
          field="pre"
          title="pre"
          width="75px"
          sortable={false}
          editable={false}
          cell={(props) => (
            <PrePostComponenant
              {...props}
              
              HeatMapConfigDataOpportunity={this.state.HeatMapConfigDataOpportunity}
              HeatMapConfigDataThreat={this.state.HeatMapConfigDataThreat}
              dynamicHeatmapProbabilityRange={this.state.dynamicHeatmapProbabilityRange}
            />
          )}
        />
        <Column
          field="current"
          title="current"
          width="75px"
          sortable={false}
          editable={false}
          cell={(props) => (
            <PrePostComponenant
              {...props}
              
              HeatMapConfigDataOpportunity={this.state.HeatMapConfigDataOpportunity}
              HeatMapConfigDataThreat={this.state.HeatMapConfigDataThreat}
              dynamicHeatmapProbabilityRange={this.state.dynamicHeatmapProbabilityRange}
            />
          )}
        />
        <Column
          field="post"
          title="post"
          width="75px"
          sortable={false}
          editable={false}
          cell={(props) => (
            <PrePostComponenant
              {...props}
              
              HeatMapConfigDataOpportunity={this.state.HeatMapConfigDataOpportunity}
              HeatMapConfigDataThreat={this.state.HeatMapConfigDataThreat}
              dynamicHeatmapProbabilityRange={this.state.dynamicHeatmapProbabilityRange}
            />
          )}
        />
        {/* <Column
          field="overAll"
          title="OverAll Impact"
          width="100px"
          sortable={false}
          editable={false}
          cell={(props) => <OverallComponenant {...props} />}
        /> */}
        {/* New  */}

        <Column
          field="preRiskScore"
          title="Risk Score (Pre)"
          filter={"numeric"}
          width="80px"
          editable={false}
          columnMenu={(props) => (
            <ColumnMenuFilter
              {...props}
              getSelectedColumn={this.getSelectedColumn}
            />
          )}
          headerClassName={this.setClassName("preRiskScore")}
        />

        {isPrime && (
          <Column
            field="preWeightedRiskScore"
            title="Prime Risk Score (Pre)"
            filter={"numeric"}
            width="80px"
            editable={false}
            columnMenu={(props) => (
              <ColumnMenuFilter
                {...props}
                getSelectedColumn={this.getSelectedColumn}
              />
            )}
            headerClassName={this.setClassName("preWeightedRiskScore")}
            cell={(props) => (
              <td>
                <span>
                  {props.dataItem.isPrimeWorkstreams &&
                  secureLocalStorage.getItem("isPrime") == true
                    ? props.dataItem.preWeightedRiskScore
                    : ""}
                </span>
              </td>
            )}
          />
        )}

        <Column
          field="currentRiskScore"
          title="Risk Score (Current)"
          filter={"numeric"}
          width="80px"
          editable={false}
          headerClassName={this.setClassName("currentRiskScore")}
          columnMenu={(props) => (
            <ColumnMenuFilter
              {...props}
              getSelectedColumn={this.getSelectedColumn}
            />
          )}
          cell={(props) => (
            <td>
              <span className="turquoiseBlue">
                {props.dataItem.currentRiskScore}
              </span>
            </td>
          )}
        />

        {isPrime && (
          <Column
            field="currentWeightedRiskScore"
            title="Prime Risk Score (Current)"
            filter={"numeric"}
            width="80px"
            editable={false}
            headerClassName={this.setClassName("currentWeightedRiskScore")}
            columnMenu={(props) => (
              <ColumnMenuFilter
                {...props}
                getSelectedColumn={this.getSelectedColumn}
              />
            )}
            cell={(props) => (
              <td>
                <span className="turquoiseBlue">
                  {props.dataItem.isPrimeWorkstreams &&
                  secureLocalStorage.getItem("isPrime") == true
                    ? props.dataItem.currentWeightedRiskScore
                    : ""}
                </span>
              </td>
            )}
          />
        )}

        <Column
          field="postRiskScore"
          title="Risk Score (Post)"
          filter={"numeric"}
          width="80px"
          editable={false}
          headerClassName={this.setClassName("postRiskScore")}
          columnMenu={(props) => (
            <ColumnMenuFilter
              {...props}
              getSelectedColumn={this.getSelectedColumn}
            />
          )}
          cell={(props) => (
            <td>
              <span className="yellowCell">{props.dataItem.postRiskScore}</span>
            </td>
          )}
        />

        {isPrime && (
          <Column
            field="postWeightedRiskScore"
            title="Prime Risk Score (Post)"
            filter={"numeric"}
            width="80px"
            editable={false}
            headerClassName={this.setClassName("postWeightedRiskScore")}
            columnMenu={(props) => (
              <ColumnMenuFilter
                {...props}
                getSelectedColumn={this.getSelectedColumn}
              />
            )}
            cell={(props) => (
              <td>
                <span className="yellowCell">
                  {props.dataItem.isPrimeWorkstreams &&
                  secureLocalStorage.getItem("isPrime") == true
                    ? props.dataItem.postWeightedRiskScore
                    : ""}
                </span>
              </td>
            )}
          />
        )}
        {/* End  */}
        {this.state.impactColumns}
        <Column
          field="impactComments"
          title="Consequences"
          width="120px"
          columnMenu={(props) => (
            <ColumnMenuFilter
              {...props}
              getSelectedColumn={this.getSelectedColumn}
            />
          )}
          headerClassName={this.setClassName("impactComments")}
        />
        <Column
          field="proximityDate"
          title="Proximity Date"
          width="120px"
          editor="date"
          filter={"date"}
          format="{0:dd-MMM-yyyy}"
          columnMenu={(props) => (
            <ColumnMenuFilter
              {...props}
              getSelectedColumn={this.getSelectedColumn}
            />
          )}
          headerClassName={this.setClassName("proximityDate")}
        />
<Column
          field="createdDate"
          title="created Date"
          filter={"date"}
          width="100px"
          format="{0:dd-MMM-yyyy}"
          editable={false}
          columnMenu={(props) => (
            <ColumnMenuFilter
              {...props}
              getSelectedColumn={this.getSelectedColumn}
            />
          )}
          headerClassName={this.setClassName("createdDate")}
        />
          <Column
          field="createdByName"
          title="created By"
          width="100px"
          editable={false}
          columnMenu={(props) => (
            <ColumnMenuFilter
              {...props}
              getSelectedColumn={this.getSelectedColumn}
            />
          )}
          headerClassName={this.setClassName("createdByName")}
        />
        <Column
          field="isClosed"
          title="Status"
          width="70px"
          // editor="boolean"
          editable={false}
          cell={(props) => (
            <StatusComponent {...props} onEditCell={this.onEditCell} />
          )}
          
          columnMenu={(props) => (
            <ColumnMenuCheckboxFilter
              {...props}
              data={this.state.riskList}
              getSelectedColumn={this.getSelectedColumn}
            />
          )}
          headerClassName={this.setClassName("isClosed")}
        />
        <Column
                      field="closedDate"
                      title="closed Date"
                      width="120px"
                      editor="date"
                      filter={"date"}
                      editable={false}
                      format="{0:dd-MMM-yyyy}"
                      columnMenu={(props) => (
                        <ColumnMenuFilter
                          {...props}
                          getSelectedColumn={this.getSelectedColumn}
                        />
                      )}
                      headerClassName={this.setClassName("closedDate")}
                    />
        
      </Grid>
    );
    return (
      <div className="riskViewCont">
        {/* <PDFExport
          ref={this.pdfExportComponent}
          // paperSize="auto"
          forcePageBreak=".page-break"
          margin={40}
          fileName={'Analytics_report'}
          author="Riskwell Team"
          paperSize={["1000mm", "600mm"]} 
          title={'Risk Registor List - '+CreatedDate}
        > */}
        <div className="rvRow">
          {this.state.loader ? (
            <span className="MatTableSpinner">
              <CircularProgress style={{ color: "#FFFFFF" }} size={70} />
            </span>
          ) : null}
          <div className="sidebar">
            <a
              class="sidebarNavIcon"
              onClick={() => this.openSidebar(this.state.openSiderBar)}
            >
              <img src={Images.SETTINGS} width="18" alt="Stream" />
            </a>
            <div
              ref={(node) => {
                this.node = node;
              }}
              className={
                this.state.openSiderBar === true ? "gbox show" : "gbox"
              }
            >
              <div className="header">
                Workstream
                <a
                  title="Reset page"
                  className="refreshDataset"
                  onClick={this.refreshPage}
                >
                  <img src={Images.REFRESH} width="10" />
                </a>
              </div>
              <div className="treeView">
                <OrganizationTreeList
                  orgUnitData={this.state.data}
                  getRiskList={this.getRiskList}
                  getEmptyRiskList={this.setEmptyRiskList}
                  ref="child"
                />

                <div className="gBoxSelection autoHeight">
                  <div className="qdReports">
                    <div className="secHeader pointer d-flex">
                      <h5>Select Risk Dataset</h5>
                      <div className="iconCont">
                        <a
                          onClick={() => this.ToggleRiskDataset()}
                          className={
                            this.state.showRiskDataSet
                              ? "opened arrowIcon"
                              : "arrowIcon"
                          }
                        >
                          <img src={Images.ARROW} width="10" />
                        </a>
                      </div>
                    </div>
                    {this.state.showRiskDataSet ? (
                      <div className="viewConts analListViewCont">
                        <div className="listView">
                          <ul>
                            {this.state.riskDatasetList &&
                              this.state.riskDatasetList.map((data, index) => {
                                return (
                                  <li
                                    className={
                                      data.id == this.state.viewId
                                        ? "active"
                                        : ""
                                    }
                                  >
                                    <div class="dbLists"  onClick={() =>
                                          this.selectViewAction(data)
                                        }>
                                      <span className="statusIcon">
                                        <img
                                          src={
                                            data.scope == 0
                                              ? Images.LOCK
                                              : Images.UNLOCK
                                          }
                                          className="stateIcon"
                                          width="20"
                                        />
                                      </span>
                                      <h5
                                        onClick={() =>
                                          this.selectViewAction(data)
                                        }
                                      >
                                        <h5
                                          title={
                                            data.description
                                              ? data.description
                                              : "Description not available"
                                          }
                                        >
                                          {data.name}
                                        </h5>
                                      </h5>
                                    </div>
                                  </li>
                                );
                              })}
                          </ul>
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div id="capture" className="riskConts">
            <div className="gBox">
              <div className="d-flex">
                <div className="iconBox">
                  <img src={Images.ASSESSMENT} width="16" alt="Dashboard" />
                </div>
                <div className="dbConfigData">
                  <p>Total Risks</p>
                  <h4>
                    {this.state.riskCountMonteCarlo.totalRiskCount
                      ? this.state.riskCountMonteCarlo.totalRiskCount
                      : 0}
                  </h4>
                </div>
              </div>

              <div className="d-flex">
                <div className="iconBox">
                  <img src={Images.WARNING} width="16" alt="Dashboard" />
                </div>
                <div className="dbConfigData">
                  <p>Open Risks</p>
                  <h4>
                    {this.state.riskCountMonteCarlo.openRiskCount
                      ? this.state.riskCountMonteCarlo.openRiskCount
                      : 0}
                  </h4>
                </div>
              </div>

              <div className="d-flex">
                <div className="iconBox">
                  <img src={Images.CHECKCIRCLE} width="16" alt="Dashboard" />
                </div>
                <div className="dbConfigData">
                  <p>Closed Risks</p>
                  <h4>
                    {this.state.riskCountMonteCarlo.closedRiskCount
                      ? this.state.riskCountMonteCarlo.closedRiskCount
                      : 0}
                  </h4>
                </div>
              </div>
              {/* ----New--- */}
              <div className="d-flex">
                <div className="iconBox">
                  <img src={Images.UNAPPROVE} width="16" alt="Dashboard" />
                </div>
                <div className="dbConfigData">
                  <p>Unapproved Action Cost</p>
                  <h4>
                    {secureLocalStorage.getItem("currency")}
                    {this.state.aggregations.unApprovedRiskBudget
                      ? formatNumber(
                          this.state.aggregations.unApprovedRiskBudget,
                          "##,#"
                        )
                      : 0}
                  </h4>
                </div>
              </div>
              <div className="d-flex">
                <div className="iconBox">
                  <img src={Images.CHECKCIRCLE} width="16" alt="Dashboard" />
                </div>
                <div className="dbConfigData">
                  <p>Approved Action Cost</p>
                  <h4>
                    {secureLocalStorage.getItem("currency")}
                    {this.state.aggregations.riskBudgetApproved
                      ? formatNumber(
                          this.state.aggregations.riskBudgetApproved,
                          "##,#"
                        )
                      : 0}
                  </h4>
                </div>
              </div>
            </div>
            <div className="gBox">
              <div className="d-flex">
                <div className="iconBox">
                  <img src={Images.ASSESSMENT} width="16" alt="Dashboard" />
                </div>
                <div className="dbConfigData">
                  <p>Total Actions</p>
                  <h4>
                    {this.state.actionCountMonteCarlo.totalActionCount
                      ? this.state.actionCountMonteCarlo.totalActionCount
                      : 0}
                  </h4>
                </div>
              </div>

              <div className="d-flex">
                <div className="iconBox">
                  <img src={Images.WARNING} width="16" alt="Dashboard" />
                </div>
                <div className="dbConfigData">
                  <p>Open Actions</p>
                  <h4>
                    {this.state.actionCountMonteCarlo.openActionCount
                      ? this.state.actionCountMonteCarlo.openActionCount
                      : 0}
                  </h4>
                </div>
              </div>

              <div className="d-flex">
                <div className="iconBox">
                  <img src={Images.CLOSEDRISK} width="16" alt="Dashboard" />
                </div>
                <div className="dbConfigData">
                  <p>Closed Actions</p>
                  <h4>
                    {this.state.actionCountMonteCarlo.closedActionCount
                      ? this.state.actionCountMonteCarlo.closedActionCount
                      : 0}
                  </h4>
                </div>
              </div>
              <div className="d-flex">
                <div className="iconBox">
                  <img src={Images.VIEWDATA} width="16" alt="Dashboard" />
                </div>
                <div className="dbConfigData">
                  <p>Original Overdue Actions</p>
                  <h4>
                    {this.state.actionCountMonteCarlo.overdueActionCount
                      ? this.state.actionCountMonteCarlo.overdueActionCount
                      : 0}
                  </h4>
                </div>
              </div>
              <div className="d-flex">
                <div className="iconBox">
                  <img src={Images.VIEWDATA} width="16" alt="Dashboard" />
                </div>
                <div className="dbConfigData">
                  <p>Projected Overdue Actions</p>
                  <h4>
                    {this.state.actionCountMonteCarlo.projectedOverdueActionCount
                      ? this.state.actionCountMonteCarlo.projectedOverdueActionCount
                      : 0}
                  </h4>
                </div>
              </div>
            </div>
            <div className="gbox" id="rw-tab-header">
              <div className="header regCont">
                <div class="d-flex align-items-center mb-1">
                  <h5>Risks</h5>
                </div>

                <ul>
                  <li>
                    <small>Select Impact</small>
                    <DropDownList
                      data={this.state.impactslist}
                      value={this.state.Impact}
                      // defaultValue="Impact Value"
                      valueField="impactId"
                      textField="name"
                      onChange={(e) => {
                        this.setState({
                          ...this.state,
                          Impact: e.target.value,
                        });
                      }}
                    />
                  </li>
                  <li className="smallField">
                    <small>Percentile</small>
                    <DropDownList
                      data={this.Percentile}
                      value={this.state.Percentile}
                      defaultValue={"P50"}
                      onChange={(e) =>
                        this.setState({
                          ...this.state,
                          Percentile: e.target.value,
                        })
                      }
                    />
                  </li>
                  <li className="smallField">
                    <small>No. of Iterations</small>
                    <DropDownList
                      data={this.Iteration}
                      value={this.state.Iteration}
                      defaultValue={this.state.Iteration}
                      // valueField="impactId"
                      // textField="name"
                      onChange={(e) => {
                        this.setState({
                          ...this.state,
                          Iteration: e.target.value,
                        });
                      }}
                    />
                    {/* <input
                      type="number"
                      placeholder="No. of Iterations"
                      value={this.state.Iteration}
                      step={100}
                      onChange={(e) => {
                        this.setState({
                          ...this.state,
                          Iteration: e.target.value,
                        });
                      }}
                    /> */}
                  </li>
                  {/* <li onClick={this.openPercentailePopup} > */}
                  <li onClick={this.runMonteCarle}>
                    <button
                      disabled={!this.state.Impact || !this.state.Iteration}
                    >
                      Run Monte Carlo
                    </button>
                  </li>
                  {/* <li>
                    <button className="monteexportbtn" onClick={this.exportPDF}>
                      <img src={Images.PDF} alt="Export PDF" width="15" />
                    </button>
                  </li> */}
                </ul>
              </div>

              <div
                className="tblCont riskRegister dataGrids reportsGrid AnalyticsRisks"
                id="AnalyticsRisks"
              >
                {grid}
                <GridPDFExport
                  ref={(pdfExport) => (this.gridPDFExport = pdfExport)}
                  fileName={"Montecarlo_report"}
                  margin="1cm"
                  date={new Date()}
                  paperSize={["800mm", "400mm"]}
                  title={"Risk List - " + CreatedDate}
                  repeatHeaders={true}
                >
                  {grid}
                </GridPDFExport>
              </div>
            </div>
            {/* <h3 className="page-break"></h3> */}
            <div
              // id="capture"
              className=" reportChartContainer"
              ref={this.myRef}
            >
              <div id="page-break" class="chartBox flexChartBox">
                <div class="cards">
                  <h2>Pre-Mitigated - Threat</h2>
                  <HistogramChart
                    {...this.props}
                    isOpportunity={false}
                    histogramResponse={this.state.nonmitigatedHistogramResponse}
                    title="Pre-Mitigated - Threat"
                  />
              
                </div>

                <div class="cards">
                  <h2>Post-Mitigated - Threat</h2>

                  <HistogramChart
                    {...this.props}
                    isOpportunity={false}
                    histogramResponse={this.state.mitigatedHistogramResponse}
                    title="Post-Mitigated - Threat"
                  />
                </div>
              </div>

              {/* //Opportunity */}
              <h3 className="page-break"></h3>
              <div id="page-break1" class="chartBox flexChartBox">
                <div class="cards">
                  <h2>Unrealised Opportunity</h2>
                  <HistogramChart
                    {...this.props}
                    isOpportunity={true}
                    histogramResponse={
                      this.state.nonmitigatedHistogramResponseOpportunity
                    }
                    title="Unrealised Opportunity"
                  />
                </div>

                <div class="cards">
                  <h2> Realised Opportunity</h2>
                  <HistogramChart
                    {...this.props}
                    isOpportunity={true}
                    histogramResponse={
                      this.state.mitigatedHistogramResponseOpportunity
                    }
                    title="Realised Opportunity"
                  />
                </div>
              </div>

              <h3 className="page-break"></h3>
              <div
                id="page-break2"
                class="chartBox flexChartBox tornodoAnalyticsChart"
              >
               
                <div class="cards">
                  <h2 style={{color: "white", whiteSpace: "nowrap"}}>
                    Pre-Mitigated - Threat : Probability and Impact ranking
                    {this.state.Impact
                      ? " - " + this.state.Impact.name + " / " + this.state.Impact.units
                      : ""}
                  </h2>

                  <div style={{marginBottom: "10px"}}>
                    <RadioGroup
                      aria-label="pre-mitigated-threat-tornado-option"
                      name="pre-mitigated-threat-tornado-option"
                      value={this.state.preMitigatedThreatTornadoOption}
                      onChange={(e) => this.setState({ preMitigatedThreatTornadoOption: e.target.value })}
                      row
                    >
                      <FormControlLabel
                        value="all"
                        control={<Radio size="small" style={{color: "white"}} />}
                        label={<span style={{color: "white", fontSize: "12px"}}>All Values</span>}
                      />
                      <FormControlLabel
                        value="top10"
                        control={<Radio size="small" style={{color: "white"}} />}
                        label={<span style={{color: "white", fontSize: "12px"}}>Top 10 Values</span>}
                      />
                    </RadioGroup>
                  </div>
                  <TornadoChart
                    {...this.props}
                    isOpportunity={false}
                    optionSelection={this.state.preMitigatedThreatTornadoOption}
                    tornodoResponse={this.getFilteredTornadoData(this.state.nonmitigatedTornodoResponse, this.state.preMitigatedThreatTornadoOption)}
                    title={`Pre-Mitigated - Threat : Probability and Impact ranking${this.state.Impact ? " - " + this.state.Impact.name + " / " + this.state.Impact.units : ""}`}
                  />
                </div>
                <div class="cards">
                  <h2 style={{color: "white", whiteSpace: "nowrap"}}>
                    Post-Mitigated - Threat : Probability and Impact ranking
                    {this.state.Impact
                      ? " - " + this.state.Impact.name + " / " + this.state.Impact.units
                      : ""}
                  </h2>
                  <div style={{marginBottom: "10px"}}>
                    <RadioGroup
                      aria-label="post-mitigated-threat-tornado-option"
                      name="post-mitigated-threat-tornado-option"
                      value={this.state.postMitigatedThreatTornadoOption}
                      onChange={(e) => this.setState({ postMitigatedThreatTornadoOption: e.target.value })}
                      row
                    >
                      <FormControlLabel
                        value="all"
                        control={<Radio size="small" style={{color: "white"}} />}
                        label={<span style={{color: "white", fontSize: "12px"}}>All Values</span>}
                      />
                      <FormControlLabel
                        value="top10"
                        control={<Radio size="small" style={{color: "white"}} />}
                        label={<span style={{color: "white", fontSize: "12px"}}>Top 10 Values</span>}
                      />
                    </RadioGroup>
                  </div>
                  <TornadoChart
                    {...this.props}
                    isOpportunity={false}
                    optionSelection={this.state.postMitigatedThreatTornadoOption}
                    tornodoResponse={this.getFilteredTornadoData(this.state.mitigatedTornodoResponse, this.state.postMitigatedThreatTornadoOption)}
                    title={`Post-Mitigated - Threat : Probability and Impact ranking${this.state.Impact ? " - " + this.state.Impact.name + " / " + this.state.Impact.units : ""}`}
                  />
                </div>
              </div>

              {/* //Opportunity */}
              <h3 className="page-break"></h3>
              <div
                id="page-break3"
                class="chartBox flexChartBox tornodoAnalyticsChart"
              >
                <div class="cards">
                  <h2 style={{color: "white", whiteSpace: "nowrap"}}>
                    Unrealised Opportunity : Probability and Impact ranking
                    {this.state.Impact
                      ? " - " + this.state.Impact.name + " / " + this.state.Impact.units
                      : ""}
                  </h2>
                  <div style={{marginBottom: "10px"}}>
                    <RadioGroup
                      aria-label="unrealised-opportunity-tornado-option"
                      name="unrealised-opportunity-tornado-option"
                      value={this.state.unrealisedOpportunityTornadoOption}
                      onChange={(e) => this.setState({ unrealisedOpportunityTornadoOption: e.target.value })}
                      row
                    >
                      <FormControlLabel
                        value="all"
                        control={<Radio size="small" style={{color: "white"}} />}
                        label={<span style={{color: "white", fontSize: "12px"}}>All Values</span>}
                      />
                      <FormControlLabel
                        value="top10"
                        control={<Radio size="small" style={{color: "white"}} />}
                        label={<span style={{color: "white", fontSize: "12px"}}>Top 10 Values</span>}
                      />
                    </RadioGroup>
                  </div>
                  <TornadoChart
                    {...this.props}
                    isOpportunity={true}
                    optionSelection={this.state.unrealisedOpportunityTornadoOption}
                    tornodoResponse={this.getFilteredTornadoData(this.state.nonmitigatedTornodoResponseOpportunity, this.state.unrealisedOpportunityTornadoOption)}
                    title={`Unrealised Opportunity : Probability and Impact ranking${this.state.Impact ? " - " + this.state.Impact.name + " / " + this.state.Impact.units : ""}`}
                  />
                </div>
                <div class="cards">
                  <h2 style={{color: "white", whiteSpace: "nowrap"}}>
                    Realised Opportunity : Probability and Impact ranking
                    {this.state.Impact
                      ? " - " + this.state.Impact.name + " / " + this.state.Impact.units
                      : ""}
                  </h2>
                  <div style={{marginBottom: "10px"}}>
                    <RadioGroup
                      aria-label="realised-opportunity-tornado-option"
                      name="realised-opportunity-tornado-option"
                      value={this.state.realisedOpportunityTornadoOption}
                      onChange={(e) => this.setState({ realisedOpportunityTornadoOption: e.target.value })}
                      row
                    >
                      <FormControlLabel
                        value="all"
                        control={<Radio size="small" style={{color: "white"}} />}
                        label={<span style={{color: "white", fontSize: "12px"}}>All Values</span>}
                      />
                      <FormControlLabel
                        value="top10"
                        control={<Radio size="small" style={{color: "white"}} />}
                        label={<span style={{color: "white", fontSize: "12px"}}>Top 10 Values</span>}
                      />
                    </RadioGroup>
                  </div>
                  <TornadoChart
                    {...this.props}
                    isOpportunity={true}
                    optionSelection={this.state.realisedOpportunityTornadoOption}
                    tornodoResponse={this.getFilteredTornadoData(this.state.mitigatedTornodoResponseOpportunity, this.state.realisedOpportunityTornadoOption)}
                    title={`Realised Opportunity : Probability and Impact ranking${this.state.Impact ? " - " + this.state.Impact.name + " / " + this.state.Impact.units : ""}`}
                  />
                </div>
              </div>
              <h3 className="page-break"></h3>
              <div id="page-break3" class="chartBox flexChartBox">
                <div class="cards">
                  <h2 style={{color: "white", whiteSpace: "nowrap"}}>
                    Pre-Mitigated Threat : Tornado
                    {this.state.Impact
                      ? " - " + this.state.Impact.name + " / " + this.state.Impact.units
                      : ""}
                  </h2>
                  <div style={{marginBottom: "10px"}}>
                    <RadioGroup
                      aria-label="pre-mitigated-threat-full-tornado-option"
                      name="pre-mitigated-threat-full-tornado-option"
                      value={this.state.preMitigatedThreatFullTornadoOption}
                      onChange={(e) => this.setState({ preMitigatedThreatFullTornadoOption: e.target.value })}
                      row
                    >
                      <FormControlLabel
                        value="all"
                        control={<Radio size="small" style={{color: "white"}} />}
                        label={<span style={{color: "white", fontSize: "12px"}}>All Values</span>}
                      />
                      <FormControlLabel
                        value="top10"
                        control={<Radio size="small" style={{color: "white"}} />}
                        label={<span style={{color: "white", fontSize: "12px"}}>Top 10 Values</span>}
                      />
                    </RadioGroup>
                  </div>
                  <FullTornadoChart
                    {...this.props}
                    optionSelection={this.state.preMitigatedThreatFullTornadoOption}
                    tornodoResponse={this.getFilteredFullTornadoData(this.state.nonMitigatedFullTornodoResponses, this.state.preMitigatedThreatFullTornadoOption)}
                    title={`Pre-Mitigated Threat : Tornado${this.state.Impact ? " - " + this.state.Impact.name + " / " + this.state.Impact.units : ""}`}
                  />
                </div>
                <div class="cards">
                  <h2 style={{color: "white", whiteSpace: "nowrap"}}>
                    Post-Mitigated Threat : Tornado
                    {this.state.Impact
                      ? " - " + this.state.Impact.name + " / " + this.state.Impact.units
                      : ""}
                  </h2>
                  <div style={{marginBottom: "10px"}}>
                    <RadioGroup
                      aria-label="post-mitigated-threat-full-tornado-option"
                      name="post-mitigated-threat-full-tornado-option"
                      value={this.state.postMitigatedThreatFullTornadoOption}
                      onChange={(e) => this.setState({ postMitigatedThreatFullTornadoOption: e.target.value })}
                      row
                    >
                      <FormControlLabel
                        value="all"
                        control={<Radio size="small" style={{color: "white"}} />}
                        label={<span style={{color: "white", fontSize: "12px"}}>All Values</span>}
                      />
                      <FormControlLabel
                        value="top10"
                        control={<Radio size="small" style={{color: "white"}} />}
                        label={<span style={{color: "white", fontSize: "12px"}}>Top 10 Values</span>}
                      />
                    </RadioGroup>
                  </div>
                  <FullTornadoChart
                    {...this.props}
                    optionSelection={this.state.postMitigatedThreatFullTornadoOption}
                    tornodoResponse={this.getFilteredFullTornadoData(this.state.mitigatedFullTornodoResponses, this.state.postMitigatedThreatFullTornadoOption)}
                    title={`Post-Mitigated Threat : Tornado${this.state.Impact ? " - " + this.state.Impact.name + " / " + this.state.Impact.units : ""}`}
                  />
                </div>
              </div>
              <h3 className="page-break"></h3>
              <div id="page-break3" class="chartBox flexChartBox">
                <div class="cards">
                  <h2 style={{color: "white", whiteSpace: "nowrap"}}>
                    Unrealised Opportunity : Tornado
                    {this.state.Impact
                      ? " - " + this.state.Impact.name + " / " + this.state.Impact.units
                      : ""}
                  </h2>
                  <div style={{marginBottom: "10px"}}>
                    <RadioGroup
                      aria-label="unrealised-opportunity-full-tornado-option"
                      name="unrealised-opportunity-full-tornado-option"
                      value={this.state.unrealisedOpportunityFullTornadoOption}
                      onChange={(e) => this.setState({ unrealisedOpportunityFullTornadoOption: e.target.value })}
                      row
                    >
                      <FormControlLabel
                        value="all"
                        control={<Radio size="small" style={{color: "white"}} />}
                        label={<span style={{color: "white", fontSize: "12px"}}>All Values</span>}
                      />
                      <FormControlLabel
                        value="top10"
                        control={<Radio size="small" style={{color: "white"}} />}
                        label={<span style={{color: "white", fontSize: "12px"}}>Top 10 Values</span>}
                      />
                    </RadioGroup>
                  </div>
                  <FullTornadoChart
                    {...this.props}
                    isOpportunity={true}
                    optionSelection={this.state.unrealisedOpportunityFullTornadoOption}
                    tornodoResponse={this.getFilteredFullTornadoData(this.state.nonMitigatedOppFullTornodoResponses, this.state.unrealisedOpportunityFullTornadoOption)}
                    title={`Unrealised Opportunity : Tornado${this.state.Impact ? " - " + this.state.Impact.name + " / " + this.state.Impact.units : ""}`}
                  />
                </div>
                <div class="cards">
                  <h2 style={{color: "white", whiteSpace: "nowrap"}}>
                    Realised Opportunity : Tornado
                    {this.state.Impact
                      ? " - " + this.state.Impact.name + " / " + this.state.Impact.units
                      : ""}
                  </h2>
                  <div style={{marginBottom: "10px"}}>
                    <RadioGroup
                      aria-label="realised-opportunity-full-tornado-option"
                      name="realised-opportunity-full-tornado-option"
                      value={this.state.realisedOpportunityFullTornadoOption}
                      onChange={(e) => this.setState({ realisedOpportunityFullTornadoOption: e.target.value })}
                      row
                    >
                      <FormControlLabel
                        value="all"
                        control={<Radio size="small" style={{color: "white"}} />}
                        label={<span style={{color: "white", fontSize: "12px"}}>All Values</span>}
                      />
                      <FormControlLabel
                        value="top10"
                        control={<Radio size="small" style={{color: "white"}} />}
                        label={<span style={{color: "white", fontSize: "12px"}}>Top 10 Values</span>}
                      />
                    </RadioGroup>
                  </div>
                  <FullTornadoChart
                    {...this.props}
                    isOpportunity={true}
                    optionSelection={this.state.realisedOpportunityFullTornadoOption}
                    tornodoResponse={this.getFilteredFullTornadoData(this.state.mitigatedOppFullTornodoResponses, this.state.realisedOpportunityFullTornadoOption)}
                    title={`Realised Opportunity : Tornado${this.state.Impact ? " - " + this.state.Impact.name + " / " + this.state.Impact.units : ""}`}
                  />
                </div>
              </div>
            </div>
            <h3 className="page-break"></h3>
            <div id="page-break4" className="gbox impactGbox ">
              <h2>Impact </h2>
              <div className="header">
                <ul>
                  <li>
                    <DropDownList
                      data={this.Percentile}
                      defaultValue="Percentile"
                      onChange={(e) =>
                        this.setState({
                          ...this.state,
                          Percentile: e.target.value,
                        })
                      }
                    />
                  </li>
                  {/* <li>
                        
                    <small>Select Impact</small>
                    <DropDownList
                      data={this.state.impactslist}
                      // defaultValue="Impact Value"
                      valueField="impactId"
                      textField="name"
                      onChange={(e) => {
                        this.setState({
                          ...this.state,
                          Impact: e.target.value
                        })
                      }
                      }
                    />
                  </li>
                  
                  <li>
                    <input type="number" placeholder="No. of Iterations"
                     onChange={(e) => {
                        this.setState({
                          ...this.state,
                          Iteration: e.target.value
                        })
                      }
                      }/>
                  </li> */}
                  {/* <li onClick={this.openPercentailePopup} > */}
                  <li onClick={this.runMonteCarleForGrid}>
                    <button
                    // disabled={!this.state.Impact || !this.state.Iteration}
                    >
                      Run Monte Carlo
                    </button>
                  </li>
                </ul>
              </div>
              <div class="dataGrids impactTbl" id="rw-tab-header">
                <Grid
                  data={this.state.impactGridData}
                  reorderable
                  resizable
                  sortable={true}
                >
                  <Column field="impactName" title="Impact" width="170" />
                  <Column
                    field="current"
                    title="Pre-Mitigated Threat"
                    cell={(props) => <CurrencyFormat {...props} />}
                  />
                  <Column
                    field="revised"
                    title="Post-Mitigated Threat"
                    cell={(props) => <CurrencyFormat {...props} />}
                  />
                  <Column
                    field="oppCurrent"
                    title="Unrealised Opportunity"
                    cell={(props) => <CurrencyFormat {...props} />}
                  />
                  <Column
                    field="oppRevised"
                    title="Realised Opportunity"
                    cell={(props) => <CurrencyFormat {...props} />}
                  />
                  {/* <Column field="percentage" title="Percentage"  /> */}
                </Grid>
              </div>
            </div>
          </div>
        </div>
        {/* </PDFExport> */}
        <Popup
          show={this.state.openPercentaileModelFlag}
          popupClass={"popup-content"}
        >
          {this.state.loader ? (
            <span className="MatTableSpinner">
              <CircularProgress style={{ color: "#FFFFFF" }} size={70} />
            </span>
          ) : null}
          <div className="deleteModelCont">
            <DropDownList
              data={this.Percentile}
              defaultValue="Percentile"
              onChange={(e) => {
                this.setState({
                  ...this.state,
                  Percentile: e.target.value,
                });
              }}
            />

            <div className="btnCont">
              <button
                disabled={!this.state.Percentile}
                onClick={this.runMonteCarle}
                className="deleteBtn"
                type="button"
              >
                Run
              </button>
              <button
                onClick={this.closePercentailePopup}
                className="cancelBtn"
                type="button"
              >
                Cancel
              </button>
            </div>
          </div>
        </Popup>
      </div>
    );
  }
  onItemClick = (event) => {
    event.item.selected = !event.item.selected;
    this.forceUpdate();
  };
}
export default connect()(MonteCarlo);
